import { REWARD_OFFERING } from "../../constants";
import CompetitionPage from "../../common/components/CompetitionPage";

function SydneyMarathon42kmMain() {
  const offerId = REWARD_OFFERING.sydneyMarathon42km;

  return (
    <CompetitionPage
      offerId={offerId}
    />
  );
}

export default SydneyMarathon42kmMain;
